// @ts-nocheck
import { takeLatest } from "redux-saga/effects";
import {
  postAPIDataV3,
} from "utils/api";
import * as sagaActions from "./sagaActions";
import * as constants from "./constants";
import { getDispatch, getState } from "reducers";
import {
  refreshGridData,
} from "models/dynamicGrid/sagaActions";
import { getMultiSelectOptions } from "organisms/multiSelect/selectors";
import { getGridFilters, getTableSelection } from "models/dynamicGrid/selector";
import { createFiltersFromQueries } from "models/dynamicGrid/query";
import { REQUESTS } from "utils/services/thetaretail/requests";

async function deleteColumnAlias({ payload: { ColumnName } }) {
  try {
    const tableSelection = getTableSelection(
      getState(),
      constants.COLUMNS_TABLE_ID
    );
    const searchParams = getGridFilters(getState(), constants.COLUMNS_TABLE_ID);
    const dispatch = getDispatch();
    await postAPIDataV3({
      service: REQUESTS.POST.REMOVE_COLUMN_ALIAS.service,
      url: REQUESTS.POST.REMOVE_COLUMN_ALIAS.url,
      body: {
        rowIdentifier: ColumnName || tableSelection?.selectedRowKeys,
        isSelectAll: tableSelection?.isSelectAll,
        selectAllSearch: JSON.stringify({
          filter: createFiltersFromQueries(searchParams?.search),
        }),
      },
    });
    dispatch(
      refreshGridData({
        tableId: constants.COLUMNS_TABLE_ID,
      })
    );
  } catch (e) {
    console.log(e);
  }
}

async function createAppColumnAlias({ payload: { columnName, aliasName } }) {
  try {
    const { options } = getMultiSelectOptions(
      getState(),
      constants.SELECTION_COMPONENT
    );
    const selectedColumn = options.find((o) => o.label === columnName);
    const dispatch = getDispatch();
    await postAPIDataV3({
      service: REQUESTS.POST.ADD_COLUMN_ALIAS.service,
      url: REQUESTS.POST.ADD_COLUMN_ALIAS.url,
      body: {
        AppColumnName: selectedColumn?.value,
        AppColumnAlias: aliasName,
        AppColumn: selectedColumn?.label,
      },
    });
    dispatch(
      refreshGridData({
        tableId: constants.COLUMNS_TABLE_ID,
      })
    );
  } catch (e) {
    console.log(e);
  }
}

export default function* rootSaga() {
  return [
    yield takeLatest(sagaActions.triggerDeleteColumnAlias, deleteColumnAlias),
    yield takeLatest(
      sagaActions.triggerCreateAppColumnAlias,
      createAppColumnAlias
    ),
  ];
}
